// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"246":"62108066","290":"471cd84b","415":"bf4b5d4c","512":"b521dc16","649":"829ceebf"}[chunkId] + ".chunk.js";
};